module.exports = __webpack_public_path__ + "static/media/E1-3.cae16f41.png";